import { httpClient } from '../api/http-client';
import type {
  ContenidoPublico,
  ContenidoPublicoGrouped,
  CreateContenidoPublicoRequest,
  PaginaPublica,
  UpdateContenidoPublicoRequest,
} from '../../types/contenido-publico';

interface ApiResponse<T> {
  data: T;
  statusCode: number;
  timestamp: string;
}

class ContenidoPublicoService {
  async findAll(params?: { pagina?: PaginaPublica; seccion?: string; activo?: boolean }): Promise<ContenidoPublico[]> {
    const response = await httpClient.get<ApiResponse<ContenidoPublico[]>>('/contenido-publico', { params });
    return response.data.data;
  }

  async findByPagina(pagina: PaginaPublica): Promise<ContenidoPublicoGrouped> {
    const response = await httpClient.get<ApiResponse<ContenidoPublicoGrouped>>(`/contenido-publico/publico/${pagina}`);
    return response.data.data;
  }

  async create(data: CreateContenidoPublicoRequest): Promise<ContenidoPublico> {
    const response = await httpClient.post<ApiResponse<ContenidoPublico>>('/contenido-publico', data);
    return response.data.data;
  }

  async update(id: string, data: UpdateContenidoPublicoRequest): Promise<ContenidoPublico> {
    const response = await httpClient.put<ApiResponse<ContenidoPublico>>(`/contenido-publico/${id}`, data);
    return response.data.data;
  }

  async toggleActivo(id: string): Promise<ContenidoPublico> {
    const response = await httpClient.patch<ApiResponse<ContenidoPublico>>(`/contenido-publico/${id}/activar`, {});
    return response.data.data;
  }

  async delete(id: string): Promise<{ message: string }> {
    const response = await httpClient.delete<ApiResponse<{ message: string }>>(`/contenido-publico/${id}`);
    return response.data.data;
  }
}

export const contenidoPublicoService = new ContenidoPublicoService();
